module.exports = __webpack_public_path__ + "static/media/header-desktop.5a42d5b3.png";